import { Component, OnInit } from "@angular/core";
import { AbogadoDetail } from "app/fiscalia/domain/abogado-detail";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-abogados-profiles-detail",
  templateUrl: "./abogados-profiles-detail.component.html",
  styleUrls: ["./abogados-profiles-detail.component.scss"]
})
export class AbogadosProfilesDetailComponent implements OnInit {
  abogado: AbogadoDetail;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.abogado = data.abogado;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/abogados-profiles/abogados-profiles-detail/abogados-profiles-detail.component.ts